export default "__VITE_ASSET__DLjFXfxT__"